import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { interviewContent, ambassadorPortrait } from '../data/interview';

const InterviewTeaser = () => {
  const { language } = useLanguage();
  const i = interviewContent[language] || interviewContent.fr;

  return (
    <section
      id="interview"
      data-testid="interview-teaser-section"
      className="bg-[#1a1c1b] py-20 md:py-28 border-t border-[#3f4816]/40"
    >
      <div className="max-w-[87.5rem] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Portrait */}
          <div className="lg:col-span-5">
            <div className="relative">
              {/* Frame accent */}
              <div className="absolute -inset-2 border border-[#d9fb06]/20 rounded-sm" />
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-[#d9fb06]/10 rounded-sm hidden md:block" />
              <div className="relative overflow-hidden rounded-sm aspect-[4/5] bg-[#0f1110]">
                <img
                  src={ambassadorPortrait}
                  alt={`${i.ambassador} - ${i.role}`}
                  className="w-full h-full object-cover grayscale-[15%]"
                  data-testid="interview-ambassador-portrait"
                />
                {/* Caption strip */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1a1c1b] via-[#1a1c1b]/85 to-transparent px-5 py-4">
                  <div className="text-[#d9fb06] text-[0.65rem] tracking-[0.2em] uppercase font-semibold mb-1">
                    S.E.M. / H.E. / V.E.
                  </div>
                  <div className="text-white text-base md:text-lg font-bold leading-tight">
                    {i.ambassador}
                  </div>
                  <div className="text-[#888680] text-xs md:text-sm mt-1">{i.role}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-10 bg-[#d9fb06]" />
              <span className="text-[#d9fb06] text-xs tracking-[0.25em] uppercase font-semibold">
                {i.eyebrow}
              </span>
            </div>

            <h2 className="font-black text-white text-3xl sm:text-4xl md:text-5xl lg:text-[3.5rem] uppercase leading-[0.95] mb-6">
              {i.title}
              <span className="block text-[#d9fb06] mt-2">{i.ambassador}</span>
            </h2>

            <div className="relative pl-6 mb-8 border-l-2 border-[#d9fb06]/40">
              <Quote
                className="absolute -left-3 -top-2 w-5 h-5 text-[#d9fb06] bg-[#1a1c1b]"
                strokeWidth={2.5}
              />
              <p className="text-[#c9c7c0] text-base md:text-lg leading-relaxed italic">
                {i.teaserIntro}
              </p>
            </div>

            <Link
              to="/interview-ambassadeur"
              data-testid="interview-read-full-cta"
              className="group inline-flex items-center gap-3 bg-[#d9fb06] text-[#1a1c1b] px-7 py-4 rounded-full font-bold text-sm uppercase tracking-wider hover:bg-white transition-all duration-300"
            >
              {i.ctaRead}
              <ArrowRight
                size={18}
                className="group-hover:translate-x-1 transition-transform"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InterviewTeaser;
